export default __webpack_public_path__ + "static/media/goat.adaac826.mp3";